import * as React from 'react';
import { DeviceType } from '../../shared/types/ast';

type Props = {
    id: string;
    deviceType: DeviceType;
    className?: string;
};

export function AdSenseForShopping(props: Props) {
    const { id = 'afshcontainer', deviceType, className = 'ads__unit' } = props;

    const style = {
        border: '0',
        padding: '0px',
        marginTop: deviceType === 'mobile' ? '8px' : '2px',
        height: deviceType === 'mobile' ? 'unset' : 'auto',
    };

    return (
        <div id={id} className={className} style={style} aria-hidden="true" />
    );
}
